import { AUTH_ROUTE_PATHS } from './auth/config';

export const PUBLIC_ROUTE_PATHS = {
  ...AUTH_ROUTE_PATHS,
};

export default { RoutePaths: PUBLIC_ROUTE_PATHS };
